import React, { useEffect } from "react";
import { fetchCertificates } from "../../../../../redux/actions/catalog/catalog";
import { useAppDispatch, useAppSelector } from "../../../../../redux/hooks";
import { mapIDescriptionToDropDownOptions } from "../../../../../utils";
import { CustomSelector, ISelectorProps } from "../../../../common/selectors/customSelector/customSelector";

export const CustomCertificateSelector: React.FC<ISelectorProps> = ({ onChange, selectedKey, name, title, disabled }) => {
    const { data } = useAppSelector((store) => store.catalog.certificates);
    const dispatch = useAppDispatch();

    useEffect(() => {
        data.length === 0 && dispatch(fetchCertificates());
    }, []);

    return (
        <CustomSelector
            title={title}
            options={mapIDescriptionToDropDownOptions(data)}
            onChange={onChange}
            selectedKey={selectedKey}
            name={name}
            disabled={disabled}
        ></CustomSelector>
    );
};
